import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import moment from "moment";
import { Spin } from "antd";

import { toast } from "react-toastify";

const RolesForm = (props) => {
  const frmRef = useRef({});
  const [backImage, setBackImage] = useState(
    "https://img.freepik.com/premium-vector/anonymous-user-circle-icon-vector-illustration-flat-style-with-long-shadow_520826-1931.jpg?w=1060"
  );

  const [empData, setEmpData] = useState();
  const [empId, setEmpId] = useState();
  const [servicesData, setServicesData] = useState();
  const [moduleServicesData, setModuleServicesData] = useState();
  const [servicesList, setServicesList] = useState();
  const { sendRequest: getUser } = useHttp();
  const [dataLoading, setDataLoading] = useState(false);

  const employeeData = () => {
    getUser(
      {
        url: `/api/employee/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setEmpData(res.output);
        }
      }
    );
  };

  useEffect(() => {
    employeeData();
  }, [getUser]);

  const handleEmpChange = (e) => {
    //console.log(e.target.value);
    const id = e.target.value;

    setEmpId(id);

    const filteredEmp =
      empData &&
      empData.filter((item) => parseInt(item.empId) === parseInt(id));

    if (filteredEmp && filteredEmp.length > 0) {
      serviceAllData(filteredEmp[0].userId);
      frmRef.current.user_case.value = filteredEmp[0].useCase;

      frmRef.current.email.value = filteredEmp[0].workEmailId;

      frmRef.current.employee_code.value = filteredEmp[0].employeeCode ?? "";

      frmRef.current.designation.value = filteredEmp[0].designationName;

      frmRef.current.department.value = filteredEmp[0].departmentName;
      setBackImage(
        `${process.env.REACT_APP_FILE_URL}${
          filteredEmp && filteredEmp[0].profileurl
        }`
      );
    } else {
      frmRef.current.user_case.value = "";
      frmRef.current.email.value = "";
      frmRef.current.employee_code.value = "";
      frmRef.current.designation.value = "";
      frmRef.current.department.value = "";
    }
  };

  const { sendRequest: getServiceData } = useHttp();
  useEffect(() => {
    getServiceData(
      {
        url: `/api/serviceAllocationToOrganizationByOrgId/?orgId=${localStorage.getItem(
          "orgId"
        )}&&isWebService=1`,
      },
      (res) => {
        setServicesData(res);
      }
    );
  }, []);

  const { sendRequest: getServiceAllData } = useHttp();

  const serviceAllData = (userId) => {
    setDataLoading(true);
    getServiceAllData(
      {
        url: `/api/serviceRoleAllocationByEmployee/?userId=${userId}`,
      },
      (data) => {
        setDataLoading(false);
        console.log("serviceRoleAllocation data", data);
        var newempRoleallocationList = [];
        var k = 0;

        console.log("servicesData data", servicesData);
        do {
          var row = servicesData[k];

          var servicefilter = data.filter(
            (item) => item.serviceId == row.serviceId
          );

          if (servicefilter && servicefilter.length) {
            newempRoleallocationList = newempRoleallocationList.concat({
              ...row,
              canAddStatus: servicefilter[0].canAddStatus,
              canEditStatus: servicefilter[0].canEditStatus,
              canViewStatus: servicefilter[0].canViewStatus,
              canDeleteStatus: servicefilter[0].canDeleteStatus,
              canPdfStatus: servicefilter[0].canPdfStatus,
              canApproveStatus: servicefilter[0].canApproveStatus,
            });
          } else {
            newempRoleallocationList = newempRoleallocationList.concat({
              ...row,
              canAddStatus: false,
              canEditStatus: false,
              canViewStatus: false,
              canDeleteStatus: false,
              canPdfStatus: false,
              canApproveStatus: false,
            });
          }

          k++;
        } while (servicesData.length > k);

        console.log("newempRoleallocationList data", newempRoleallocationList);

        setServicesList(newempRoleallocationList);

        var mainList = [];

        var moduleList = [...new Set(servicesData.map((q) => q.moduleName))];

        var useCase = "AdminPanel";

        var k = 1;
        moduleList.forEach((item) => {
          var subNewList = [];

          var SubList = servicesData.filter((x) => x.moduleName == item);

          var serviceSubList = [
            ...new Set(SubList.map((q) => q.serviceSubName)),
          ];

          var j = 1;
          serviceSubList.forEach((subItem) => {
            var serviceList = newempRoleallocationList.filter(
              (y) => y.moduleName == item && y.serviceSubName == subItem
            );

            if (serviceList && serviceList.length > 0) {
              var i = 1;
              serviceList = serviceList.map((obj) => ({
                ...obj,
                servicesrno: i++,
              }));

              subNewList = subNewList.concat({
                serviceSubId: serviceList[0].serviceSubId,
                serviceSubsrno: j,
                serviceSubName: serviceList[0].serviceSubName,
                serviceDetail: serviceList,
                createdBy: parseInt(localStorage.getItem("id")),
              });

              j++;
            }
          });

          if (SubList && SubList.length > 0) {
            mainList = mainList.concat({
              moduleId: SubList[0].moduleId,
              modulesrno: k,
              moduleName: SubList[0].moduleName,
              subList: subNewList,
              createdBy: parseInt(localStorage.getItem("id")),
            });

            k++;
          }
        });
        setModuleServicesData([...mainList]);

        console.log("Module New List mainList", mainList);
      },
      (error) => {
        console.log(error);
        setDataLoading(false);
      }
    );
  };

  // useEffect(() => {
  //   serviceAllData();
  // }, [getServiceAllData]);

  const handleSubServiceCheckChange = (
    e,
    serviceSubId,
    Type,
    modulesrno,
    serviceSubsrno
  ) => {
    //console.log("Type serviceSubId", serviceSubId);
    const id = e.target.checked;

    var servicesTempList = servicesList;

    var moduleServicesTempData = moduleServicesData;

    var k = 0;
    do {
      var row = servicesTempList[k];

      if (row.serviceSubId === serviceSubId) {
        servicesTempList[k].canViewStatus = e.target.checked;
        servicesTempList[k].canAddStatus = e.target.checked;
        servicesTempList[k].canEditStatus = e.target.checked;
        servicesTempList[k].canPdfStatus = e.target.checked;
        servicesTempList[k].canDeleteStatus = e.target.checked;
        servicesTempList[k].canApproveStatus = e.target.checked;
      }

      k++;
    } while (servicesTempList.length > k);

    var numrows =
      moduleServicesTempData[modulesrno - 1].subList[serviceSubsrno - 1]
        .serviceDetail.length;

    for (var j = 0; j < numrows; j++) {
      try {
        moduleServicesTempData[modulesrno - 1].subList[
          serviceSubsrno - 1
        ].serviceDetail[j].canViewStatus = e.target.checked;

        moduleServicesTempData[modulesrno - 1].subList[
          serviceSubsrno - 1
        ].serviceDetail[j].canAddStatus = e.target.checked;

        moduleServicesTempData[modulesrno - 1].subList[
          serviceSubsrno - 1
        ].serviceDetail[j].canEditStatus = e.target.checked;

        moduleServicesTempData[modulesrno - 1].subList[
          serviceSubsrno - 1
        ].serviceDetail[j].canPdfStatus = e.target.checked;

        moduleServicesTempData[modulesrno - 1].subList[
          serviceSubsrno - 1
        ].serviceDetail[j].canDeleteStatus = e.target.checked;

        moduleServicesTempData[modulesrno - 1].subList[
          serviceSubsrno - 1
        ].serviceDetail[j].canApproveStatus = e.target.checked;
      } catch (error) {
        //console.log('An error occurred:', error);
      }
    }

    setServicesList(servicesTempList);

    setModuleServicesData([...moduleServicesTempData]);
  };
  const handleCheckChange = (
    e,
    serviceId,
    Type,
    modulesrno,
    serviceSubsrno,
    servicesrno
  ) => {
    console.log("Type ", Type);
    console.log("serviceSubsrno ", serviceSubsrno);
    console.log("servicesrno ", servicesrno);

    const id = e.target.checked;

    var servicesTempList = servicesList;

    var moduleServicesTempData = moduleServicesData;
    console.log("moduleServicesTempData ", moduleServicesTempData);
    var k = 0;
    do {
      var row = servicesTempList[k];

      if (row.serviceId === serviceId) {
        if (Type == "canView") {
          servicesTempList[k].canViewStatus = e.target.checked;
          moduleServicesTempData[modulesrno - 1].subList[
            serviceSubsrno - 1
          ].serviceDetail[servicesrno - 1].canViewStatus = e.target.checked;

          servicesTempList[k].canAddStatus = e.target.checked;
          moduleServicesTempData[modulesrno - 1].subList[
            serviceSubsrno - 1
          ].serviceDetail[servicesrno - 1].canAddStatus = e.target.checked;
          servicesTempList[k].canEditStatus = e.target.checked;
          moduleServicesTempData[modulesrno - 1].subList[
            serviceSubsrno - 1
          ].serviceDetail[servicesrno - 1].canEditStatus = e.target.checked;
          servicesTempList[k].canPdfStatus = e.target.checked;
          moduleServicesTempData[modulesrno - 1].subList[
            serviceSubsrno - 1
          ].serviceDetail[servicesrno - 1].canPdfStatus = e.target.checked;
          servicesTempList[k].canDeleteStatus = e.target.checked;

          moduleServicesTempData[modulesrno - 1].subList[
            serviceSubsrno - 1
          ].serviceDetail[servicesrno - 1].canDeleteStatus = e.target.checked;

          servicesTempList[k].canApproveStatus = e.target.checked;
          moduleServicesTempData[modulesrno - 1].subList[
            serviceSubsrno - 1
          ].serviceDetail[servicesrno - 1].canApproveStatus = e.target.checked;
        }

        if (Type == "canAdd") {
          servicesTempList[k].canAddStatus = e.target.checked;
          moduleServicesTempData[modulesrno - 1].subList[
            serviceSubsrno - 1
          ].serviceDetail[servicesrno - 1].canAddStatus = e.target.checked;
        }

        if (Type == "canEdit") {
          servicesTempList[k].canEditStatus = e.target.checked;
          moduleServicesTempData[modulesrno - 1].subList[
            serviceSubsrno - 1
          ].serviceDetail[servicesrno - 1].canEditStatus = e.target.checked;
        }

        if (Type == "canPdf") {
          servicesTempList[k].canPdfStatus = e.target.checked;
          moduleServicesTempData[modulesrno - 1].subList[
            serviceSubsrno - 1
          ].serviceDetail[servicesrno - 1].canPdfStatus = e.target.checked;
        }
        if (Type == "canDelete") {
          servicesTempList[k].canDeleteStatus = e.target.checked;
          moduleServicesTempData[modulesrno - 1].subList[
            serviceSubsrno - 1
          ].serviceDetail[servicesrno - 1].canDeleteStatus = e.target.checked;
        }
        if (Type == "canApprove") {
          servicesTempList[k].canApproveStatus = e.target.checked;
          moduleServicesTempData[modulesrno - 1].subList[
            serviceSubsrno - 1
          ].serviceDetail[servicesrno - 1].canApproveStatus = e.target.checked;
        }
      }

      k++;
    } while (servicesTempList.length > k);

    setServicesList(servicesTempList);

    setModuleServicesData([...moduleServicesTempData]);
  };

  const { sendRequest: getserviceAllDatabyEmpId } = useHttp();

  const serviceAllDatabyEmpId = (userId) => {
    getserviceAllDatabyEmpId(
      {
        url: `/api/menuServiceRoleAllocation/?userId=${localStorage.getItem(
          "id"
        )}`,
      },
      (data) => {
        var menuData = data.output;

        localStorage.setItem("userMenu", JSON.stringify(menuData));
      }
    );
  };

  const { sendRequest: postRoles } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault(false);

    var userId = 0;
    var userlist = empData.filter(
      (item) => item.empId == frmRef.current.employee_name.value
    );
    if (userlist && userlist.length > 0) {
      userId = userlist[0].userId;
    }
    var newempList = [];
    servicesList &&
      servicesList.map((itm, i) => {
        newempList = newempList.concat({
          canAddStatus: itm.canAddStatus,
          canEditStatus: itm.canEditStatus,
          canViewStatus: itm.canViewStatus,
          canPdfStatus: itm.canPdfStatus,
          canDeleteStatus: itm.canDeleteStatus,
          serviceId: itm.serviceId,
          userId: userId,
          orgId: parseInt(localStorage.getItem("orgId")),
          createdBy: parseInt(localStorage.getItem("id")),
          createdDate: moment(new Date().toISOString().slice(0, 10)).format(
            "DD/MM/YYYY"
          ),
        });
      });

    //console.log(newempList);

    postRoles(
      {
        url: "/api/serviceRoleAllocation/",
        method: "POST",
        body: newempList,
      },
      (data) => {
        props.addForm(false);
        serviceAllDatabyEmpId(userId);
        toast.success("Roles and Permissions Updated");
      }
    );
  };

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            &nbsp;
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Roles and Permissions Form </h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3 text-center">
                      <div className="form-group mt-5">
                        <img
                          src={`${backImage}`}
                          className="user-image img-circle"
                          width="160"
                          height="160"
                          alt="User Image"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Employee Name</label>
                        <select
                          className="form-control"
                          style={{ width: "100%" }}
                          ref={(el) => (frmRef.current["employee_name"] = el)}
                          onChange={handleEmpChange}
                          required
                        >
                          <option value="">Select</option>
                          {empData &&
                            empData.map((x) => (
                              <option
                                key={x.empId}
                                value={x.empId}
                                // selected={
                                //   props.update && x.empId === props.update.empId
                                // }
                              >
                                {x.employeeName}
                              </option>
                            ))}{" "}
                        </select>
                      </div>
                      <div className="form-group">
                        <label>Employee Code</label>
                        <input
                          ref={(el) => (frmRef.current["employee_code"] = el)}
                          readOnly
                          type="text"
                          className="form-control"
                          style={{ width: "100%" }}
                        />
                      </div>
                      <div className="form-group">
                        <label>Designation</label>
                        <input
                          type="text"
                          className="form-control"
                          style={{ width: "100%" }}
                          readOnly
                          ref={(el) => (frmRef.current["designation"] = el)}
                        />
                      </div>
                    </div>
                    {/* /.col */}
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>User Case</label>
                        <input
                          className="form-control"
                          style={{ width: "100%" }}
                          ref={(el) => (frmRef.current["user_case"] = el)}
                          readOnly
                        />
                      </div>
                      <div className="form-group">
                        <label>Email ID</label>
                        <input
                          type="text"
                          className="form-control"
                          style={{ width: "100%" }}
                          ref={(el) => (frmRef.current["email"] = el)}
                          readOnly
                        />
                      </div>
                      <div className="form-group">
                        <label>Department</label>
                        <input
                          type="text"
                          className="form-control"
                          style={{ width: "100%" }}
                          ref={(el) => (frmRef.current["department"] = el)}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>

                  {dataLoading ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "200px",
                      }}
                    >
                      <h3 className="text-center">Loading...</h3>
                      <Spin size="large" />
                    </div>
                  ) : moduleServicesData && moduleServicesData.length === 0 ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "200px",
                        fontWeight: "bold",
                      }}
                    >
                      No Data Found
                    </div>
                  ) : (
                    <div className="row">
                      <div className="col-md-1"></div>
                      <div className="col-md-11">
                        {moduleServicesData &&
                          moduleServicesData.map((itm, i) => {
                            return (
                              <div style={{ width: "800px" }}>
                                <div className="row">{itm.moduleName}</div>
                                <div className="row">
                                  {itm.subList &&
                                    itm.subList.map((subitm, i) => {
                                      return (
                                        <div style={{ width: "800px" }}>
                                          <div className="row">{"   "}</div>

                                          <div className="row">
                                            <table className="table table-bordered text-center">
                                              <thead>
                                                <tr>
                                                  <th>
                                                    <input
                                                      className="form-check-input"
                                                      type="checkbox"
                                                      id={"SubService"}
                                                      ref={(el) =>
                                                        (frmRef.current[
                                                          "SubService"
                                                        ] = el)
                                                      }
                                                      onChange={(e) => {
                                                        handleSubServiceCheckChange(
                                                          e,
                                                          subitm.serviceSubId,
                                                          "canView",
                                                          itm.modulesrno,
                                                          subitm.serviceSubsrno
                                                        );
                                                      }}
                                                    />

                                                    {subitm.serviceSubName}
                                                  </th>
                                                  <th colSpan={5}></th>
                                                </tr>

                                                <tr>
                                                  <th>Service Name</th>
                                                  <th> Service Access</th>
                                                  <th> Add</th>
                                                  <th> Edit</th>

                                                  <th> Delete</th>
                                                  <th> Pdf</th>

                                                  {/* <th> Approve</th> */}
                                                </tr>
                                              </thead>

                                              <tbody>
                                                {subitm.serviceDetail &&
                                                  subitm.serviceDetail.map(
                                                    (serviceitm, i) => {
                                                      return (
                                                        <tr key={i}>
                                                          <td>
                                                            {
                                                              serviceitm.serviceName
                                                            }
                                                          </td>

                                                          <td>
                                                            <input
                                                              className="form-check-input"
                                                              type="checkbox"
                                                              id={"can_view"}
                                                              ref={(el) =>
                                                                (frmRef.current[
                                                                  "can_view"
                                                                ] = el)
                                                              }
                                                              defaultChecked={
                                                                serviceitm.canViewStatus
                                                              }
                                                              checked={
                                                                serviceitm.canViewStatus
                                                              }
                                                              onChange={(e) => {
                                                                handleCheckChange(
                                                                  e,
                                                                  serviceitm.serviceId,
                                                                  "canView",
                                                                  itm.modulesrno,
                                                                  subitm.serviceSubsrno,
                                                                  serviceitm.servicesrno
                                                                );
                                                              }}
                                                            />{" "}
                                                          </td>
                                                          <td>
                                                            <input
                                                              className="form-check-input"
                                                              type="checkbox"
                                                              id={"can_Add"}
                                                              ref={(el) =>
                                                                (frmRef.current[
                                                                  "can_Add"
                                                                ] = el)
                                                              }
                                                              defaultChecked={
                                                                serviceitm.canAddStatus
                                                              }
                                                              checked={
                                                                serviceitm.canAddStatus
                                                              }
                                                              onChange={(e) => {
                                                                handleCheckChange(
                                                                  e,
                                                                  serviceitm.serviceId,
                                                                  "canAdd",
                                                                  itm.modulesrno,
                                                                  subitm.serviceSubsrno,
                                                                  serviceitm.servicesrno
                                                                );
                                                              }}
                                                            />
                                                          </td>

                                                          <td>
                                                            <input
                                                              className="form-check-input"
                                                              type="checkbox"
                                                              id={"can_Edit"}
                                                              defaultChecked={
                                                                serviceitm.canEditStatus
                                                              }
                                                              checked={
                                                                serviceitm.canEditStatus
                                                              }
                                                              onChange={(e) => {
                                                                handleCheckChange(
                                                                  e,
                                                                  serviceitm.serviceId,
                                                                  "canEdit",
                                                                  itm.modulesrno,
                                                                  subitm.serviceSubsrno,
                                                                  serviceitm.servicesrno
                                                                );
                                                              }}
                                                            />
                                                          </td>
                                                          <td>
                                                            {" "}
                                                            <input
                                                              className="form-check-input"
                                                              type="checkbox"
                                                              id={"can_Delete"}
                                                              ref={(el) =>
                                                                (frmRef.current[
                                                                  "can_Delete"
                                                                ] = el)
                                                              }
                                                              defaultChecked={
                                                                serviceitm.canDeleteStatus
                                                              }
                                                              checked={
                                                                serviceitm.canDeleteStatus
                                                              }
                                                              onChange={(e) => {
                                                                handleCheckChange(
                                                                  e,
                                                                  serviceitm.serviceId,
                                                                  "canDelete",
                                                                  itm.modulesrno,
                                                                  subitm.serviceSubsrno,
                                                                  serviceitm.servicesrno
                                                                );
                                                              }}
                                                            />
                                                          </td>
                                                          <td>
                                                            {" "}
                                                            <input
                                                              className="form-check-input"
                                                              type="checkbox"
                                                              id={"can_Pdf"}
                                                              ref={(el) =>
                                                                (frmRef.current[
                                                                  "can_Pdf"
                                                                ] = el)
                                                              }
                                                              defaultChecked={
                                                                serviceitm.canPdfStatus
                                                              }
                                                              checked={
                                                                serviceitm.canPdfStatus
                                                              }
                                                              onChange={(e) => {
                                                                handleCheckChange(
                                                                  e,
                                                                  serviceitm.serviceId,
                                                                  "canPdf",
                                                                  itm.modulesrno,
                                                                  subitm.serviceSubsrno,
                                                                  serviceitm.servicesrno
                                                                );
                                                              }}
                                                            />
                                                          </td>

                                                          {/* <td>
                                                          {" "}
                                                          <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id={"can_Approve"}
                                                            ref={(el) =>
                                                              (frmRef.current[
                                                                "can_Approve"
                                                              ] = el)
                                                            }
                                                            defaultChecked={
                                                              serviceitm.canApproveStatus
                                                            }
                                                            checked={
                                                              serviceitm.canApproveStatus
                                                            }
                                                            onChange={(e) => {
                                                              handleCheckChange(
                                                                e,
                                                                serviceitm.serviceId,
                                                                "canApprove",
                                                                itm.modulesrno,
                                                                subitm.serviceSubsrno,
                                                                serviceitm.servicesrno
                                                              );
                                                            }}
                                                          />
                                                        </td> */}
                                                        </tr>
                                                      );
                                                    }
                                                  )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  )}
                  <hr />

                  <div className=" text-right">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default RolesForm;
